import LoginTemplate from "./src/login.vue";
import LogoutTemplate from "./src/logout.vue";

export const Login = function (Vue) {
  const LoginConstructor = Vue.extend(LoginTemplate);

  let instance = new LoginConstructor({
    Vue,
  }).$mount();

  document.body.appendChild(instance.$el);

  return instance;
};

export let Logout = function (Vue) {
  const LogoutConstructor = Vue.extend(LogoutTemplate);
  let instance = new LogoutConstructor({
    Vue,
  }).$mount();

  document.body.appendChild(instance.$el);

  instance.show = true;

  return instance;
};

Logout.close = function () {
  this.show = false;
};

export const LoginInstall = function (Vue) {
  Vue.prototype.$login = function () {
    return Login(Vue);
  };
};

export const LogoutInstall = function (Vue) {
  Vue.prototype.$logout = function () {
    return Logout(Vue);
  };
};
